import * as React from 'react';

const SvgCheckr = (props) => (
  <svg
    width={props.width || 24}
    height={props.height || 25}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.1929 0.5H4.80714C2.15223 0.5 0 2.65223 0 5.30714V19.6929C0 22.3478 2.15223 24.5 4.80714 24.5H19.1929C21.8478 24.5 24 22.3478 24 19.6929V5.30714C24 2.65223 21.8478 0.5 19.1929 0.5Z"
      fill="#009BB5"
    />
    <path
      d="M15.451 13.7427C14.8392 15.1674 13.7073 15.9526 12.2666 15.9526C10.3642 15.9526 8.87249 14.3502 8.87249 12.3035C8.87249 10.2568 10.3321 8.69524 12.2666 8.69524C13.6869 8.69524 14.88 9.46292 15.4568 10.7492L15.4976 10.841L19.0345 9.61588L18.9952 9.51099C17.958 6.73451 15.3884 5.00977 12.287 5.00977C8.08442 5.01122 4.91602 8.13732 4.91602 12.2831C4.91602 14.2905 5.66622 16.1492 7.0297 17.5156C8.39469 18.8849 10.2549 19.638 12.2652 19.638C15.4117 19.638 18.0104 17.8608 19.0461 14.9984L19.084 14.8935L15.4889 13.6495L15.4481 13.7427H15.451Z"
      fill="white"
    />
  </svg>
);

export default SvgCheckr;
